// extracted by mini-css-extract-plugin
export default {"toggle":"view-toggle_toggle__POQ9Q","option":"view-toggle_option__ijzsF","active":"view-toggle_active__wEum-"};